exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Reviews-top-if1Ww::before {\r\n    top: 11px;\r\n}", ""]);

// exports
exports.locals = {
	"top": "Reviews-top-if1Ww"
};